import { REJECT_WITHDRAWAL } from '../../routes';
import customAxios from "../../customAxios";
import {WithdrawalNamespace} from "../../../types/withdrawal.namespace";

const withdrawalRejectOne = async (props: WithdrawalNamespace.propsUpdateOne): Promise<any> => {
  try {
    return (await customAxios.put(REJECT_WITHDRAWAL, props)).data;
  } catch (error: unknown) {
    console.error({ REJECT_WITHDRAWAL: error });
    return false;
  }
};

export default withdrawalRejectOne;
